import { Truck } from "lucide-react";
import { useState } from "react";

export default function ShippingSection() {
  const [cep, setCep] = useState("");
  const [showFreightResult, setShowFreightResult] = useState(false);

  const formatCep = (value) => {
    let formattedValue = value.replace(/\D/g, "");
    if (formattedValue.length > 5) {
      formattedValue =
        formattedValue.substring(0, 5) + "-" + formattedValue.substring(5, 8);
    }
    return formattedValue;
  };

  const calculateFreight = () => {
    if (cep.replace(/\D/g, "").length !== 8) {
      alert("Por favor, digite um CEP válido");
      return;
    }
    setShowFreightResult(true);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center mb-4">
        <Truck className="h-5 w-5 text-gray-500 mr-2" />
        <h2 className="text-lg font-semibold text-gray-900">
          Método de Entrega
        </h2>
      </div>

      <div className="mb-5 p-3 border border-gray-200 rounded-md bg-gray-50">
        <p className="text-sm font-medium text-gray-700 mb-2">Calcular frete</p>
        <div className="flex items-center">
          <div className="relative flex-grow mr-2">
            <input
              type="text"
              id="cep"
              placeholder="Digite seu CEP"
              className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              maxLength={9}
            />
            <a
              href="https://buscacepinter.correios.com.br/app/endereco/index.php"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xs text-green-600 hover:text-green-800">
              Não sei meu CEP
            </a>
          </div>
          <button
            id="calcularFrete"
            className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 text-sm font-medium">
            Calcular
          </button>
        </div>
        {showFreightResult && (
          <div className="mt-2 text-sm">
            <p className="text-gray-700">
              Opções de frete disponíveis para o CEP{" "}
              <span className="font-medium">{cep}</span>:
            </p>
          </div>
        )}
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 border border-gray-200 rounded-md">
          <div className="flex items-center">
            <input
              type="radio"
              id="entrega1"
              name="entrega"
              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
              defaultChecked
            />
            <label
              htmlFor="entrega1"
              className="ml-2 block text-sm font-medium text-gray-700">
              Entrega Expressa (3-5 dias úteis)
            </label>
            <span className="text-sm font-medium text-gray-900">R$ 25,90</span>
          </div>
        </div>
        <div className="flex items-center justify-between p-3 border border-gray-200 rounded-md">
          <div className="flex items-center">
            <input
              type="radio"
              id="entrega2"
              name="entrega"
              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
            />
            <label
              htmlFor="entrega2"
              className="ml-2 block text-sm font-medium text-gray-700">
              Entrega Padrão (5-8 dias úteis)
            </label>
            <span className="text-sm font-medium text-gray-900">R$ 15,90</span>
          </div>
        </div>

        <div className="flex items-center justify-between p-3 border border-gray-200 rounded-md">
          <div className="flex items-center">
            <input
              type="radio"
              id="entrega3"
              name="entrega"
              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
            />
            <label
              htmlFor="entrega3"
              className="ml-2 block text-sm font-medium text-gray-700">
              Retirada na Loja (1-2 dias úteis)
            </label>
            <span className="text-sm font-medium text-gray-900">Grátis</span>
          </div>
        </div>
      </div>
    </div>
  );
}
